import { PatchQueueRequestComment } from 'domain/usecases';
import { BaseHttpService } from 'main/factories/http';

export class RemotePatchQueueRequestComment
  extends BaseHttpService<PatchQueueRequestComment.Model>
  implements PatchQueueRequestComment
{
  async patch(params: PatchQueueRequestComment.Params): Promise<PatchQueueRequestComment.Model> {
    return await this.request('patch', params);
  }
}
